export const DEFAULT_HTTP_RESPONSE: HttpResponse = {
    status: null,
    errMessage: '',
};
